import { EpimsBaseEntityDto } from './epim-base.dto';
export class AreaOfInterestDto extends EpimsBaseEntityDto {

    AreaOfInterestId: string;

    AreaOfInterestDesc: string;

  

 
}
